
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/position-managers/[[...slug]]",
      function () {
        return require("private-next-pages/position-managers/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/position-managers/[[...slug]]"])
      });
    }
  